<script setup lang="ts">
import type { TagsInputRootProps } from 'radix-vue'

import { type BadgeVariants, Icon } from '@/ui'

import { TagsInputInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText, TagsInputRoot } from '.'

defineProps<{
  modelValue: TagsInputRootProps['modelValue']
  variant?: BadgeVariants['variant']
  placeholder?: string
  classNames?: string
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', val: TagsInputRootProps['modelValue']): void
}>()
</script>

<template>
  <TagsInputRoot :model-value="modelValue" :class="classNames" @update:model-value="emits('update:modelValue', $event)">
    <TagsInputItem v-for="(item, i) in modelValue" :key="i" :value="item" :variant="variant">
      <TagsInputItemText />
      <TagsInputItemDelete>
        <Icon name="XMarkIcon" class="size-4" />
      </TagsInputItemDelete>
    </TagsInputItem>

    <slot v-if="$slots.default" />
    <TagsInputInput v-else :placeholder="placeholder" />
  </TagsInputRoot>
</template>
